import { Model, Collection } from '@/models/BaseModel';

import {
    equal,
    integer,
    min,
    required,
    string,
    email,
    boolean
} from 'vue-mc/validation';
import { UserType } from '@/services/LoginService';

export class Staff extends Model {
    public options() {
        return {
            identifier: 'id'
        };
    }

    public defaults() {
        return {
            id: null,
            first_name: '',
            last_name: '',
            email: '',
            password: '',
            phone: '',
            age: '',
            availability: '',
            user_type: '',
            user_id: null
        };
    }

    public mutations() {
        return {
            id: (id: any) => Number(id) || null,
            first_name: String,
            last_name: String,
            email: String,
            password: String,
            phone: String,
            age: Number,
            availability: String,
            user_type: Number,
            user_id: (id: any) => Number(id) || null
        };
    }

    public validation() {
        return {
            id: integer.and(min(1)).or(equal(null)),
            first_name: string.and(required),
            last_name: string.and(required),
            email: email.and(required),
            password: string,
            phone: string,
            age: integer,
            availability: string,
            user_type: integer.and(required).and(min(2)),
            user_id: integer.and(min(1)).or(equal(null)),
        };
    }

    public routes() {
        return {
            fetch: "staff/{id}",
            save: "staff",
            delete: "staff/{id}"
        };
    }
}

export class StaffCollection extends Collection {
    public model() {
        return Staff;
    }

    public defaults() {
        return {
            orderBy: 'first_name',
        };
    }

    public routes() {
        return {
            fetch: "staff",
        };
    }

    public fetchData() {
        return this.fetch();
    }
}
